import { generateRandomString } from './randomString.ts'

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

export function generateShortId() {
  return generateRandomString(CHARS, 6)
}
